<template>
  <div>
    <HeroBanner :page="'tournaments'"/>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
export default {
  components: {
    HeroBanner
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageTournaments.vue